import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { useStripe } from '@stripe/react-stripe-js';
import { toggleNoti, toggleError } from 'config/slice/message'
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Grid from '@mui/material/Grid';
import Checkbox from '@mui/material/Checkbox';
import { styled } from '@mui/material/styles';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import PreviewForm_vo from 'components/common/PreviewForm_vo';
import { TEXT_FORM_STEPS_TITLE } from 'config/const/text';
import CheckIcon from '@mui/icons-material/Check';
import { format } from 'date-fns';
import { useFormSubmitMutation, useGetServiceListMutation, useUpdateUserServiceListMutation } from 'config/api/waV1_user';
import { isEmpty, toInteger, toString } from 'lodash';
import { resp_services } from 'config/const/global';
import { useTranslation } from 'react-i18next';
import { EN, KEY_ERROR_FORM_FILL_FORM, KEY_ERROR_FORM_SUBMIT_FAILED, KEY_FORM_TITLE_1, KEY_FORM_TITLE_2, KEY_FORM_TITLE_3, KEY_FORM_TITLE_4, KEY_FORM_TITLE_5, KEY_FORM_TITLE_6, KEY_FORM_VO_COL_BUS_REG_LICENSE, KEY_FORM_VO_COL_BUS_REG_LICENSE_NO, KEY_FORM_VO_COL_BUS_REG_LICENSE_YES, KEY_FORM_VO_COL_BUS_REG_NUM, KEY_FORM_VO_COL_FILE_BUG_REG_COPY, KEY_FORM_VO_COL_IDENTITY, KEY_FORM_VO_COL_IDENTITY_COM, KEY_FORM_VO_COL_IDENTITY_IND, KEY_FORM_VO_COL_IDENTITY_ORG, KEY_FORM_VO_COL_IND_FILE_ADDRESS_COPY, KEY_FORM_VO_COL_MAIN_CONTACT, KEY_FORM_VO_COL_MAIN_CONTACT_ADDRESS, KEY_FORM_VO_COL_MAIN_CONTACT_BIRTHDAY, KEY_FORM_VO_COL_MAIN_CONTACT_EMAIL, KEY_FORM_VO_COL_MAIN_CONTACT_FILE_HKID_COPY, KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY, KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_AGENT, KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_DIRECTOR, KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_SECRETARY, KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_SH, KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_STAFF, KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_VERIFY, KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_VERIFY_GOTOBANK, KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_VERIFY_ONLINE, KEY_FORM_VO_COL_MAIN_CONTACT_NAME_CN, KEY_FORM_VO_COL_MAIN_CONTACT_NAME_EN, KEY_FORM_VO_COL_MAIN_CONTACT_PHONE, KEY_FORM_VO_COL_MAIN_CONTACT_TITLE, KEY_FORM_VO_COL_MAIN_CONTACT_TITLE_MISS, KEY_FORM_VO_COL_MAIN_CONTACT_TITLE_MR, KEY_FORM_VO_COL_MAIN_CONTACT_TITLE_MRS, KEY_FORM_VO_COL_NEED_UPLOAD_FILE, KEY_FORM_VO_COL_ORG_FILE_ORG_COPY, KEY_FORM_VO_COL_ORG_NUM, KEY_FORM_VO_COL_REG_CONNTRY, KEY_FORM_VO_COL_REG_DATE, KEY_FORM_VO_CONFIRM, KEY_FORM_VO_TAC_COM_1, KEY_FORM_VO_TAC_COM_2, KEY_FORM_VO_TAC_COM_3, KEY_FORM_VO_TAC_IND_1, KEY_FORM_VO_TAC_IND_2, KEY_FORM_VO_TAC_ORG_1, KEY_FORM_VO_TAC_ORG_2, KEY_FORM_VO_TAC_TIPS, KEY_FORM_VO_TITLE_1, KEY_FORM_VO_TITLE_2, KEY_FORM_VO_TITLE_3, KEY_FORM_VO_TITLE_4, KEY_LABEL_FORM_ADDRESS, KEY_LABEL_FORM_BOARD_COM_REG_ADDR, KEY_LABEL_FORM_BOARD_COM_REG_BUS_NUM, KEY_LABEL_FORM_BOARD_COM_REG_C, KEY_LABEL_FORM_BOARD_COM_REG_NUM, KEY_LABEL_FORM_BOARD_HOLADING, KEY_LABEL_FORM_BOARD_INDENTITY, KEY_LABEL_FORM_BOARD_INDENTITY_COMPANY, KEY_LABEL_FORM_BOARD_INDENTITY_DIRECTOR, KEY_LABEL_FORM_BOARD_INDENTITY_PERSONAL, KEY_LABEL_FORM_BOARD_INDENTITY_SHAREHOLDER, KEY_LABEL_FORM_BOARD_NO_AFTER, KEY_LABEL_FORM_BOARD_NO_BEFORE, KEY_LABEL_FORM_BOARD_NUM, KEY_LABEL_FORM_BOARD_NUM_NEW, KEY_LABEL_FORM_BOARD_SH_ADDRESS_AFTER, KEY_LABEL_FORM_BOARD_SH_ADDRESS_BEFORE, KEY_LABEL_FORM_BOARD_SH_CN_NAME, KEY_LABEL_FORM_BOARD_SH_EMAIL, KEY_LABEL_FORM_BOARD_SH_EN_NAME, KEY_LABEL_FORM_BOARD_SH_IC_AFTER, KEY_LABEL_FORM_BOARD_SH_IC_BEFORE, KEY_LABEL_FORM_BOARD_SH_ID_AFTER, KEY_LABEL_FORM_BOARD_SH_ID_BEFORE, KEY_LABEL_FORM_BOARD_SH_PHONE, KEY_LABEL_FORM_BUS_NATURE, KEY_LABEL_FORM_BUS_REGION, KEY_LABEL_FORM_COM_ADDR, KEY_LABEL_FORM_COM_ADDR_REG, KEY_LABEL_FORM_COM_ADDR_USE_DEFAULT, KEY_LABEL_FORM_COM_ADDR_USE_DEFAULT_NO, KEY_LABEL_FORM_COM_ADDR_USE_DEFAULT_YES, KEY_LABEL_FORM_COM_CN_NAME, KEY_LABEL_FORM_COM_EN_NAME, KEY_LABEL_FORM_CONTACT_SLOT, KEY_LABEL_FORM_CONTACT_SLOT_23, KEY_LABEL_FORM_CONTACT_SLOT_35, KEY_LABEL_FORM_CONTACT_SLOT_912, KEY_LABEL_FORM_CONTACT_WAY, KEY_LABEL_FORM_CONTACT_WAY_EMAIL, KEY_LABEL_FORM_CONTACT_WAY_PHONE, KEY_LABEL_FORM_CONTACT_WAY_WECHAT, KEY_LABEL_FORM_CONTACT_WAY_WECHAT_NO, KEY_LABEL_FORM_CONTACT_WAY_WTS, KEY_LABEL_FORM_EMAIL, KEY_LABEL_FORM_IS_NUM, KEY_LABEL_FORM_NAME, KEY_LABEL_FORM_NEXT, KEY_LABEL_FORM_PHONE, KEY_LABEL_FORM_PRESET_SHARES, KEY_LABEL_FORM_PRESET_SHARES_NO, KEY_LABEL_FORM_PRESET_SHARES_YES, KEY_LABEL_FORM_PREVIEW, KEY_LABEL_FORM_PREVIOUS, KEY_LABEL_FORM_SUBMIT, KEY_LABEL_FORM_TITLE, KEY_LABEL_FORM_TITLE_FEMALE, KEY_LABEL_FORM_TITLE_MALE, KEY_LABEL_FORM_VAL, KEY_LABEL_FORM_VALUE_ADDED, KEY_LABEL_FORM_VALUE_ADDED_BA, KEY_LABEL_FORM_VALUE_ADDED_BE, KEY_LABEL_FORM_VALUE_ADDED_CP, KEY_LABEL_FORM_VALUE_ADDED_CP_1, KEY_LABEL_FORM_VALUE_ADDED_CP_2, KEY_LABEL_FORM_VALUE_ADDED_CS, KEY_LABEL_FORM_VALUE_ADDED_CSE, KEY_LABEL_FORM_VALUE_ADDED_TM, KEY_LABEL_FORM_VAL_TOTAL, KEY_NOTI_FORM_SUBMIT_SUCC, MODULE_PREVIEW_ROUTER_FORM, ZH, ZH_CN } from 'config/const/locale';
import UploadButton from 'components/common/UploadButton';
import './index.css'
import dayjs from 'dayjs';


// custom component
const RBox = styled(Box)(({ theme }) => ({
    [theme.breakpoints.down('xl')]: {
        width: '100%'
    },
    [theme.breakpoints.up('xl')]: {
        width: '80%'
    }
}));



export default function FormA_vo({
    serveAs
}) {

    const stripe = useStripe()

    const { t } = useTranslation(MODULE_PREVIEW_ROUTER_FORM)
    const { lng, user } = useSelector(state => state?.global)

    const A_SHAREHOLDER = {
        type: '',
        identity: t(KEY_FORM_VO_COL_MAIN_CONTACT_TITLE_MR),
        en_name: '',
        zh_name: '',
        tel: '',
        email: '',
        address: '',
        date_of_birth: new Date(),
    }

    const dispatch = useDispatch()
    const [activeStep, setActiveStep] = React.useState(0);
    const [skipped, setSkipped] = React.useState(new Set());
    const [submit, setSubmit] = React.useState(false);
    // const [plans, setPlans] = React.useState(services.filter(i => i.name.includes(serveAs)).sort((a, b) => a.id - b.id))
    const [plans, setPlans] = React.useState(resp_services?.value?.value.filter(i => i.name.includes(serveAs)).sort((a, b) => a.id - b.id))
    const [shareholders, setShareholders] = React.useState([
        A_SHAREHOLDER
    ])
    const [userIpt, setUserIpt] = React.useState({
        page: plans[0]?.id,
        title: t(KEY_FORM_VO_COL_IDENTITY_COM),
        identity: t(KEY_FORM_VO_COL_MAIN_CONTACT_TITLE_MR),
        en_name: '',
        zh_name: '',
        address: '',
        company_name_en: '',
        company_name_zh: '',
        has_bus_reg_license: '1',
        reg_date: new Date(),
        bus_reg_num: '',
        reg_country: '',
        org_num: '',

        sMemberNum: '1',
        shareholders: shareholders,
        eService: []
    })
    const [fileStatus, setFileStatus] = React.useState({
        file_bug_reg: false,
        file_hkid: {
            '1': false
        },
        file_address: false,
        file_org: false
    })

    const [formSubmit] = useFormSubmitMutation()
    const [getSListFn] = useGetServiceListMutation()
    const [updateUSFn] = useUpdateUserServiceListMutation()

    const steps = [
        t(KEY_FORM_TITLE_2),
        t(KEY_FORM_VO_TITLE_1),
        t(KEY_FORM_VO_TITLE_2),
        t(KEY_FORM_VO_TITLE_3),
        t(KEY_FORM_VO_TITLE_4),
    ];

    const errors_tips = {
        en_name: t(KEY_FORM_VO_COL_MAIN_CONTACT_NAME_EN),
        zh_name: t(KEY_FORM_VO_COL_MAIN_CONTACT_NAME_CN),
        address: t(KEY_FORM_VO_COL_MAIN_CONTACT_ADDRESS),
        company_name_en: t(KEY_LABEL_FORM_COM_EN_NAME),
        company_name_zh: t(KEY_LABEL_FORM_COM_CN_NAME),
        has_bus_reg_license: userIpt.has_bus_reg_license == '1' ? t(KEY_FORM_VO_COL_BUS_REG_LICENSE_YES) : t(KEY_FORM_VO_COL_BUS_REG_LICENSE_NO),
        reg_date: t(KEY_FORM_VO_COL_REG_DATE),
        bus_reg_num: t(KEY_FORM_VO_COL_BUS_REG_NUM),
        reg_country: t(KEY_FORM_VO_COL_REG_CONNTRY),
        org_num: t(KEY_FORM_VO_COL_ORG_NUM),
    }

    const isStepOptional = (step) => {
        return step === -1;
    };

    const isStepSkipped = (step) => {
        return skipped.has(step);
    };

    const handleNext = () => {
        let newSkipped = skipped;
        if (isStepSkipped(activeStep)) {
            newSkipped = new Set(newSkipped.values());
            newSkipped.delete(activeStep);
        }

        if (activeStep == steps.length - 1) {
            if (!checkForm()) return
        }

        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        setSkipped(newSkipped);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleSkip = () => {
        if (!isStepOptional(activeStep)) {
            // You probably want to guard against something like this,
            // it should never occur unless someone's actively trying to break something.
            throw new Error("You can't skip a step that isn't optional.");
        }

        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        setSkipped((prevSkipped) => {
            const newSkipped = new Set(prevSkipped.values());
            newSkipped.add(activeStep);
            return newSkipped;
        });
    };

    const checkForm = () => {
        let flag = true
        let attr = ''
        Object.keys(userIpt)
            .filter(
                i => {
                    switch (userIpt.title) {
                        case t(KEY_FORM_VO_COL_IDENTITY_COM):
                            if (i == 'title') return false
                            if (i == 'eService') return false

                            if (i == 'identity') return false
                            if (i == 'en_name') return false
                            if (i == 'zh_name') return false
                            if (i == 'address') return false
                            if (i == 'reg_country') return false
                            if (i == 'org_num') return false
                            if ((i == 'bus_reg_num') && (userIpt.has_bus_reg_license == '0')) return false
                            return true
                        case t(KEY_FORM_VO_COL_IDENTITY_IND):
                            if (i == 'title') return false
                            if (i == 'eService') return false

                            if (i == 'company_name_en') return false
                            if (i == 'company_name_zh') return false
                            if (i == 'has_bus_reg_license') return false
                            if (i == 'reg_date') return false
                            if (i == 'bus_reg_num') return false
                            if (i == 'reg_country') return false
                            if (i == 'org_num') return false
                            return true
                        case t(KEY_FORM_VO_COL_IDENTITY_ORG):
                            if (i == 'title') return false
                            if (i == 'eService') return false

                            if (i == 'identity') return false
                            if (i == 'en_name') return false
                            if (i == 'zh_name') return false
                            if (i == 'address') return false
                            if (i == 'company_name_en') return false
                            if (i == 'company_name_zh') return false
                            if (i == 'has_bus_reg_license') return false
                            if (i == 'reg_date') return false
                            if (i == 'bus_reg_num') return false
                            return true

                        default:
                            if (i == 'title') return false
                            if (i == 'eService') return false
                            return true
                    }
                }
            )
            .reverse()
            .map(
                i => {
                    if (isEmpty(toString(userIpt[i]))) {
                        attr = i
                        flag = false
                    }
                }
            )
            .filter(
                i => {
                    if (i == 'wechat_no') return false
                    if (i == 'bus_reg_num') return false
                    return true
                }
            )

        if (!flag) {
            dispatch(toggleError({
                indicator: true,
                msg: `${t(KEY_ERROR_FORM_FILL_FORM)} - ${errors_tips[attr]}`
            }))
            return false
        }
        return true
    }

    const parseEService = () => {
        return userIpt.eService.map(i => ({ id: toInteger(i), quantity: 1 })) || []
    }

    const parseFile = () => {
        let temp1 = []
        let temp2 = []

        temp1 = Object.keys(fileStatus)
            .filter(i => (typeof fileStatus[i] == 'boolean' ? false : true))
            .filter(i =>
                (typeof fileStatus[i][Object.keys(fileStatus[i])[0]] == 'boolean' ? false : true)
            )
            .map(i => {
                if (fileStatus[i]['file_path']) return fileStatus[i]
                temp2 = Object.keys(fileStatus[i]).map(it => fileStatus[i][it])
            })
        return [...temp1, ...temp2].filter(i => i ? true : false)
    }


    const handleReset = () => {

        let temp = {}
        switch (userIpt.title) {
            case t(KEY_FORM_VO_COL_IDENTITY_COM):
                temp = {
                    services: [
                        {
                            id: toInteger(userIpt.page),
                            quantity: 1
                        },
                        ...parseEService()
                    ],
                    "payment_method": "stripe",
                    "user_service": {
                        "title": userIpt.title,
                        "company_name_en": userIpt.company_name_en,
                        "company_name_zh": userIpt.company_name_zh,
                        "has_bus_reg_license": userIpt.has_bus_reg_license,
                        "reg_date": format(userIpt.reg_date?.toISOString(), 'yyyy-MM-dd'),
                        "bus_reg_num": userIpt.bus_reg_num,
                        // "shareholders": userIpt.shareholders.map(i => ({ ...i, type: i.type.join('、') })),
                        "shareholders": userIpt.shareholders.map(i => ({ ...i, type: typeof i?.type == 'object' && i?.type?.join('、') })),
                        "files": parseFile(),
                        "name": userIpt?.shareholders[0]?.en_name
                    }
                }
                break;
            case t(KEY_FORM_VO_COL_IDENTITY_IND):
                temp = {
                    services: [
                        {
                            id: toInteger(userIpt.page),
                            quantity: 1
                        },
                        ...parseEService()
                    ],
                    "payment_method": "stripe",
                    "user_service": {
                        "title": userIpt.title,
                        "identity": userIpt.identity,
                        "en_name": userIpt.en_name,
                        "zh_name": userIpt.zh_name,
                        "address": userIpt.address,
                        // "shareholders": userIpt.shareholders.map(i => ({ ...i, type: i.type.join('、') })),
                        "shareholders": userIpt.shareholders.map(i => ({ ...i, type: typeof i?.type == 'object' && i?.type?.join('、') })),
                        "files": parseFile(),
                        "name": userIpt?.en_name
                    }
                }
                break;
            case t(KEY_FORM_VO_COL_IDENTITY_ORG):
                temp = {
                    services: [
                        {
                            id: toInteger(userIpt.page),
                            quantity: 1
                        },
                        ...parseEService()
                    ],
                    "payment_method": "stripe",
                    "user_service": {
                        "title": userIpt.title,
                        "company_name_en": userIpt.company_name_en,
                        "company_name_zh": userIpt.company_name_zh,
                        "reg_country": userIpt.reg_country,
                        "org_num": userIpt.org_num,
                        // "shareholders": userIpt.shareholders.map(i => ({ ...i, type: i.type.join('、') })),
                        "shareholders": userIpt.shareholders.map(i => ({ ...i, type: typeof i?.type == 'object' && i?.type?.join('、') })),
                        "files": parseFile(),
                        "name": userIpt?.shareholders[0]?.en_name
                    }
                }
                break;
        }

        if (!checkForm()) return

        setSubmit(true)
        formSubmit(temp)
            .then(res => {
                if (res.data?.data) {
                    stripe.redirectToCheckout({
                        sessionId: res.data?.data?.invoice?.checkoutSession?.id
                    })
                        .then(({ error }) => {
                            if (error) {
                                dispatch(toggleError({
                                    indicator: true,
                                    msg: t(KEY_ERROR_FORM_SUBMIT_FAILED)
                                }))
                            } else {
                                dispatch(toggleNoti({
                                    indicator: true,
                                    msg: t(KEY_NOTI_FORM_SUBMIT_SUCC)
                                }))
                            }
                        })
                    setActiveStep(0);
                } else {
                    dispatch(toggleError({
                        indicator: true,
                        msg: t(KEY_ERROR_FORM_SUBMIT_FAILED)
                    }))
                }
            })
            .catch(reason => {
                dispatch(toggleError({
                    indicator: true,
                    msg: t(KEY_ERROR_FORM_SUBMIT_FAILED)
                }))
                setSubmit(false)
            })
    };

    const handleArrayValue = (flag, value, array) => {
        if (flag) {
            if (new Array(...array).indexOf(value) !== -1) return array
            else return [...array, value]
        } else {
            return new Array(...array).filter(i => i !== value)
        }
    }

    const saveValue = (propsName, value) => {
        switch (propsName) {
            case 'contact_way':
                if (value !== t(KEY_LABEL_FORM_CONTACT_WAY_WECHAT))
                    setUserIpt(p => ({ ...p, 'wechat_no': '' }))
                break;
            case 'has_bus_reg_license':
                if (value !== '0')
                    setUserIpt(p => ({ ...p, 'bus_reg_num': '' }))
                break;
            case 'is_std_share_value':
                if (value !== '0')
                    setUserIpt(p => ({ ...p, 'no_shares_issued': '', 'shares_par_value': '', 'shares_total_value': '' }))
                break;

            default:
                break;
        }
        setUserIpt(p => ({ ...p, [propsName]: value }))
    }

    const addNewShareholder = () => {
        setShareholders(p => [...p, { ...A_SHAREHOLDER }])
    }

    const shareholderLayoutRenderer = React.useCallback(() => shareholders.map(
        (i, index) => (
            <React.Fragment key={index}>
                <Grid item sm={1} xs={1}></Grid>
                <Grid item sm={10} xs={10}>
                    <FormControl>
                        <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                            <FormLabel id="demo-radio-buttons-group-label" sx={{ mr: 2 }}>{t(KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY)}</FormLabel>
                            <RadioGroup
                                row
                                aria-labelledby="demo-radio-buttons-group-label"
                                value={i.type}
                                name="type"

                            >
                                <FormControlLabel value={t(KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_DIRECTOR)} control={<Checkbox checked={i.type.indexOf(t(KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_DIRECTOR)) == -1 ? false : true} onChange={(e) => { i.type = handleArrayValue(e.target.checked, e.target.value, i.type); setUserIpt(p => ({ ...p, shareholders: [...shareholders] })) }} />} label={t(KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_DIRECTOR)} />
                                <FormControlLabel value={t(KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_SH)} control={<Checkbox checked={i.type.indexOf(t(KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_SH)) == -1 ? false : true} onChange={(e) => { i.type = handleArrayValue(e.target.checked, e.target.value, i.type); setUserIpt(p => ({ ...p, shareholders: [...shareholders] })) }} />} label={t(KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_SH)} />
                                <FormControlLabel value={t(KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_SECRETARY)} control={<Checkbox checked={i.type.indexOf(t(KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_SECRETARY)) == -1 ? false : true} onChange={(e) => { i.type = handleArrayValue(e.target.checked, e.target.value, i.type); setUserIpt(p => ({ ...p, shareholders: [...shareholders] })) }} />} label={t(KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_SECRETARY)} />
                                <FormControlLabel value={t(KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_STAFF)} control={<Checkbox checked={i.type.indexOf(t(KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_STAFF)) == -1 ? false : true} onChange={(e) => { i.type = handleArrayValue(e.target.checked, e.target.value, i.type); setUserIpt(p => ({ ...p, shareholders: [...shareholders] })) }} />} label={t(KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_STAFF)} />
                                <FormControlLabel value={t(KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_AGENT)} control={<Checkbox checked={i.type.indexOf(t(KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_AGENT)) == -1 ? false : true} onChange={(e) => { i.type = handleArrayValue(e.target.checked, e.target.value, i.type); setUserIpt(p => ({ ...p, shareholders: [...shareholders] })) }} />} label={t(KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_AGENT)} />

                                {/* <FormControlLabel value={t(KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_DIRECTOR)} control={<Radio />} label={t(KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_DIRECTOR)} />
                                <FormControlLabel value={t(KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_SH)} control={<Radio />} label={t(KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_SH)} />
                                <FormControlLabel value={t(KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_SECRETARY)} control={<Radio />} label={t(KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_SECRETARY)} />
                                <FormControlLabel value={t(KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_STAFF)} control={<Radio />} label={t(KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_STAFF)} />
                                <FormControlLabel value={t(KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_AGENT)} control={<Radio />} label={t(KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_AGENT)} /> */}
                            </RadioGroup>
                        </Box>
                    </FormControl>
                </Grid>
                <Grid item sm={1} xs={1}></Grid>
                <Grid item sm={1} xs={1}></Grid>
                <Grid item sm={4} xs={4}>
                    <FormControl>
                        <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                            <FormLabel id="demo-radio-buttons-group-label" sx={{ mr: 2 }}>{t(KEY_FORM_VO_COL_MAIN_CONTACT_TITLE)} </FormLabel>
                            <RadioGroup
                                row
                                aria-labelledby="demo-radio-buttons-group-label"
                                value={i.identity}
                                name="identity"
                                onChange={(e) => {
                                    i.identity = e.target.value
                                    setUserIpt(p => ({ ...p, shareholders: [...shareholders] }))
                                }}
                            >
                                <FormControlLabel value={t(KEY_FORM_VO_COL_MAIN_CONTACT_TITLE_MR)} control={<Radio />} label={t(KEY_FORM_VO_COL_MAIN_CONTACT_TITLE_MR)} />
                                <FormControlLabel value={t(KEY_FORM_VO_COL_MAIN_CONTACT_TITLE_MISS)} control={<Radio />} label={t(KEY_FORM_VO_COL_MAIN_CONTACT_TITLE_MISS)} />
                                <FormControlLabel value={t(KEY_FORM_VO_COL_MAIN_CONTACT_TITLE_MRS)} control={<Radio />} label={t(KEY_FORM_VO_COL_MAIN_CONTACT_TITLE_MRS)} />
                                {/* <FormControlLabel value={t(KEY_FORM_VO_COL_MAIN_CONTACT_TITLE_MR)} control={<Checkbox checked={i.identity.indexOf(t(KEY_FORM_VO_COL_MAIN_CONTACT_TITLE_MR)) == -1 ? false : true} onChange={(e) => { i.identity = handleArrayValue(e.target.checked, e.target.value, i.identity); setUserIpt(p => ({ ...p, shareholders: [...shareholders] })) }} />} label={t(KEY_FORM_VO_COL_MAIN_CONTACT_TITLE_MR)} />
                                <FormControlLabel value={t(KEY_FORM_VO_COL_MAIN_CONTACT_TITLE_MISS)} control={<Checkbox checked={i.identity.indexOf(t(KEY_FORM_VO_COL_MAIN_CONTACT_TITLE_MISS)) == -1 ? false : true} onChange={(e) => { i.identity = handleArrayValue(e.target.checked, e.target.value, i.identity); setUserIpt(p => ({ ...p, shareholders: [...shareholders] })) }} />} label={t(KEY_FORM_VO_COL_MAIN_CONTACT_TITLE_MISS)} />
                                <FormControlLabel value={t(KEY_FORM_VO_COL_MAIN_CONTACT_TITLE_MRS)} control={<Checkbox checked={i.identity.indexOf(t(KEY_FORM_VO_COL_MAIN_CONTACT_TITLE_MRS)) == -1 ? false : true} onChange={(e) => { i.identity = handleArrayValue(e.target.checked, e.target.value, i.identity); setUserIpt(p => ({ ...p, shareholders: [...shareholders] })) }} />} label={t(KEY_FORM_VO_COL_MAIN_CONTACT_TITLE_MRS)} /> */}
                            </RadioGroup>
                        </Box>
                    </FormControl>
                </Grid>
                <Grid item sm={3} xs={3}>
                    <FormControl>
                        <TextField label={t(KEY_FORM_VO_COL_MAIN_CONTACT_NAME_EN)} value={i.en_name} type="text" onChange={(e) => { i.en_name = e.target.value; setUserIpt(p => ({ ...p, shareholders: [...shareholders] })) }} />
                    </FormControl>
                </Grid>
                <Grid item sm={3} xs={3}>
                    <FormControl>
                        <TextField label={t(KEY_FORM_VO_COL_MAIN_CONTACT_NAME_CN)} type="text" value={i.zh_name} onChange={(e) => { i.zh_name = e.target.value; setUserIpt(p => ({ ...p, shareholders: [...shareholders] })) }} />
                    </FormControl>
                </Grid>
                <Grid item sm={1} xs={1}></Grid>
                <Grid item sm={1} xs={1}></Grid>
                <Grid item sm={5} xs={5}>
                    <FormControl>
                        <TextField label={t(KEY_FORM_VO_COL_MAIN_CONTACT_PHONE)} type="tel" value={i.tel} onChange={(e) => { i.tel = e.target.value; setUserIpt(p => ({ ...p, shareholders: [...shareholders] })) }} />
                    </FormControl>
                </Grid>
                <Grid item sm={5} xs={5}>
                    <FormControl>
                        <TextField label={t(KEY_FORM_VO_COL_MAIN_CONTACT_EMAIL)} type="text" value={i.email} onChange={(e) => { i.email = e.target.value; setUserIpt(p => ({ ...p, shareholders: [...shareholders] })) }} />
                    </FormControl>
                </Grid>
                <Grid item sm={1} xs={1}></Grid>
                <Grid item sm={1} xs={1}></Grid>
                <Grid item sm={10} xs={10} >
                    <FormControl>
                        <TextField label={t(KEY_FORM_VO_COL_MAIN_CONTACT_ADDRESS)} type="text" value={i.address} onChange={(e) => { i.address = e.target.value; setUserIpt(p => ({ ...p, shareholders: [...shareholders] })) }} />
                    </FormControl>
                </Grid>
                <Grid item sm={1} xs={1}></Grid>
                <Grid item sm={1} xs={1}></Grid>
                <Grid item sm={3} xs={3} >
                    <FormControl>
                        {/* <TextField label={t(KEY_FORM_VO_COL_MAIN_CONTACT_BIRTHDAY)} type="text" value={i.date_of_birth} onChange={(e) => { i.date_of_birth = e.target.value; setUserIpt(p => ({ ...p, shareholders: [...shareholders] })) }} /> */}
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                label={t(KEY_FORM_VO_COL_MAIN_CONTACT_BIRTHDAY)}
                                value={dayjs(i.date_of_birth)}
                                onChange={(val) => { i.date_of_birth = val; setUserIpt(p => ({ ...p, shareholders: [...shareholders] })) }}
                            />
                        </LocalizationProvider>
                    </FormControl>
                </Grid>

                <Grid item sm={8} xs={8}></Grid>
                <Grid item sm={1} xs={1}></Grid>
                <Grid item sm={10} xs={10}>
                    <Grid item sm={12} xs={12}>&nbsp;</Grid>
                    <Grid item sm={12} xs={12}>&nbsp;</Grid>
                    <Typography variant='h6'>{t(KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_VERIFY)}</Typography>

                    <Typography variant='h5'>
                        {t(KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_VERIFY_GOTOBANK)}
                    </Typography>
                    <Typography variant='h5'>
                        {t(KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_VERIFY_ONLINE)}
                    </Typography>
                </Grid>
                <Grid item sm={1} xs={1}></Grid>
                <Grid item sm={1} xs={1}></Grid>
                <Grid item sm={10} xs={10}>
                    <Grid item sm={12} xs={12}>&nbsp;</Grid>
                    <Typography variant='h6'>{t(KEY_FORM_VO_COL_NEED_UPLOAD_FILE)}</Typography>

                    <Typography variant='h5'>
                        {t(KEY_FORM_VO_COL_MAIN_CONTACT_FILE_HKID_COPY)}
                        {
                            fileStatus.file_hkid[index + 1]
                                ? <CheckIcon color='primary' fontSize='large' />
                                : <UploadButton fileName={t(KEY_FORM_VO_COL_MAIN_CONTACT_FILE_HKID_COPY)} uid={user?.id} sid={toInteger(userIpt.page)} usid={0} customFn={(payload) => setFileStatus(p => ({ ...p, "file_hkid": { ...p.file_hkid, [index + 1]: payload } }))}>
                                    <FileUploadIcon />
                                </UploadButton>
                        }
                    </Typography>
                </Grid>
                <Grid item sm={1} xs={1}></Grid>
                <Grid item sm={12} xs={12}>&nbsp;</Grid>
            </React.Fragment>
        )
    ), [shareholders, fileStatus, fileStatus.file_hkid])

    React.useEffect(() => {

        const AA_SHAREHOLDER = {
            type: '',
            identity: t(KEY_FORM_VO_COL_MAIN_CONTACT_TITLE_MR),
            en_name: '',
            zh_name: '',
            tel: '',
            email: '',
            address: '',
            date_of_birth: new Date(),
        }

        switch (userIpt.sMemberNum) {
            case '1':
                if (shareholders.lenngth >= 2) return setShareholders(p => p.slice(0, 1))
                return setShareholders(p => p)
            case '2':
                if (shareholders.lenngth >= 3) return setShareholders(p => p.slice(0, 2))
                return setShareholders(p => [...p, ...new Array(2 - p.length).fill({ ...AA_SHAREHOLDER })])
            case '3':
                if (shareholders.lenngth >= 4) return setShareholders(p => p.slice(0, 3))
                return setShareholders(p => [...p, ...new Array(3 - p.length).fill({ ...AA_SHAREHOLDER })])
            case '4':
                if (shareholders.lenngth >= 5) return setShareholders(p => p.slice(0, 4))
                return setShareholders(p => [...p, ...new Array(4 - p.length).fill({ ...AA_SHAREHOLDER })])
            case '5':
                if (shareholders.lenngth >= 6) return setShareholders(p => p.slice(0, 5))
                return setShareholders(p => [...p, ...new Array(5 - p.length).fill({ ...AA_SHAREHOLDER })])

            default:
                if (shareholders.lenngth >= 2) return setShareholders(p => p.slice(0, 1))
                return setShareholders(p => p)
        }
    }, [userIpt.sMemberNum])

    const formSectionRenderer = React.useCallback((step) => {

        function renderPInfo() {
            switch (userIpt.title) {
                case t(KEY_FORM_VO_COL_IDENTITY_COM):
                    return (
                        <>
                            <Grid item sm={1} xs={1}></Grid>
                            <Grid item sm={5} xs={5}>
                                <FormControl>
                                    <TextField label={t(KEY_LABEL_FORM_COM_EN_NAME)} type="text" value={userIpt.company_name_en} onChange={(e) => saveValue('company_name_en', e.target.value)} />
                                </FormControl>
                            </Grid>
                            <Grid item sm={5} xs={5}>
                                <FormControl>
                                    <TextField label={t(KEY_LABEL_FORM_COM_CN_NAME)} type="text" value={userIpt.company_name_zh} onChange={(e) => saveValue('company_name_zh', e.target.value)} />
                                </FormControl>
                            </Grid>
                            <Grid item sm={1} xs={1}></Grid>

                            <Grid item sm={1} xs={1}></Grid>
                            <Grid item sm={5} xs={5}>
                                <FormControl>
                                    <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                                        <FormLabel id="demo-radio-buttons-group-label" sx={{ mr: 2 }}>{t(KEY_FORM_VO_COL_BUS_REG_LICENSE)} </FormLabel>
                                        <RadioGroup
                                            row
                                            aria-labelledby="demo-radio-buttons-group-label"
                                            defaultValue="1"
                                            value={userIpt.has_bus_reg_license}
                                            name="has_bus_reg_license"
                                            onChange={(e) => saveValue('has_bus_reg_license', e.target.value)}
                                        >
                                            <FormControlLabel value="1" control={<Radio />} label={t(KEY_FORM_VO_COL_BUS_REG_LICENSE_YES)} />
                                            <FormControlLabel value="0" control={<Radio />} label={t(KEY_FORM_VO_COL_BUS_REG_LICENSE_NO)} />
                                        </RadioGroup>
                                    </Box>
                                </FormControl>
                            </Grid>
                            <Grid item sm={5} xs={5}>
                                <FormControl>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            label={t(KEY_FORM_VO_COL_REG_DATE)}
                                            value={dayjs(userIpt.reg_date)}
                                            onChange={(newValue) => saveValue('reg_date', newValue)}
                                        />
                                    </LocalizationProvider>
                                </FormControl>
                            </Grid>
                            <Grid item sm={1} xs={1}></Grid>
                            {
                                userIpt.has_bus_reg_license == '1'
                                    ? (
                                        <>
                                            <Grid item sm={1} xs={1}></Grid>
                                            <Grid item sm={10} xs={10}>
                                                <FormControl>
                                                    <TextField label={t(KEY_FORM_VO_COL_BUS_REG_NUM)} type="text" value={userIpt.bus_reg_num} onChange={(e) => saveValue('bus_reg_num', e.target.value)} />
                                                </FormControl>
                                            </Grid>
                                            <Grid item sm={1} xs={1}></Grid>
                                        </>
                                    )
                                    : false
                            }

                            {/* offset-4 */}
                            <Grid item sm={1} xs={1}></Grid>
                            <Grid item sm={10} xs={10}>
                                <Grid item sm={12} xs={12}>&nbsp;</Grid>
                                <Grid item sm={12} xs={12}>&nbsp;</Grid>
                                <Typography variant='h6'>{t(KEY_FORM_VO_COL_NEED_UPLOAD_FILE)}</Typography>

                                <Typography variant='h5'>
                                    {t(KEY_FORM_VO_COL_FILE_BUG_REG_COPY)}
                                    {
                                        fileStatus.file_bug_reg
                                            ? <CheckIcon color='primary' fontSize='large' />
                                            : <UploadButton fileName={t(KEY_FORM_VO_COL_FILE_BUG_REG_COPY)} uid={user?.id} sid={toInteger(userIpt.page)} usid={0} customFn={(payload) => setFileStatus(p => ({ ...p, "file_bug_reg": payload }))}>
                                                <FileUploadIcon />
                                            </UploadButton>
                                    }
                                </Typography>
                            </Grid>
                            <Grid item sm={1} xs={1}></Grid>
                        </>
                    )
                case t(KEY_FORM_VO_COL_IDENTITY_IND):
                    return (
                        <>
                            <Grid item sm={1} xs={1}></Grid>
                            <Grid item sm={10} xs={10}>
                                <FormControl>
                                    <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                                        <FormLabel id="demo-radio-buttons-group-label" sx={{ mr: 2 }}>{t(KEY_FORM_VO_COL_MAIN_CONTACT_TITLE)} </FormLabel>
                                        <RadioGroup
                                            row
                                            aria-labelledby="demo-radio-buttons-group-label"
                                            value={userIpt.identity}
                                            name="identity"
                                            onChange={(e) => saveValue('identity', e.target.value)}
                                        >
                                            <FormControlLabel value={t(KEY_FORM_VO_COL_MAIN_CONTACT_TITLE_MR)} control={<Radio />} label={t(KEY_FORM_VO_COL_MAIN_CONTACT_TITLE_MR)} />
                                            <FormControlLabel value={t(KEY_FORM_VO_COL_MAIN_CONTACT_TITLE_MISS)} control={<Radio />} label={t(KEY_FORM_VO_COL_MAIN_CONTACT_TITLE_MISS)} />
                                            <FormControlLabel value={t(KEY_FORM_VO_COL_MAIN_CONTACT_TITLE_MRS)} control={<Radio />} label={t(KEY_FORM_VO_COL_MAIN_CONTACT_TITLE_MRS)} />
                                            {/* <FormControlLabel value={t(KEY_FORM_VO_COL_MAIN_CONTACT_TITLE_MR)} control={<Checkbox checked={i.identity.indexOf(t(KEY_FORM_VO_COL_MAIN_CONTACT_TITLE_MR)) == -1 ? false : true} onChange={(e) => { i.identity = handleArrayValue(e.target.checked, e.target.value, i.identity); setUserIpt(p => ({ ...p, shareholders: [...shareholders] })) }} />} label={t(KEY_FORM_VO_COL_MAIN_CONTACT_TITLE_MR)} />
                                <FormControlLabel value={t(KEY_FORM_VO_COL_MAIN_CONTACT_TITLE_MISS)} control={<Checkbox checked={i.identity.indexOf(t(KEY_FORM_VO_COL_MAIN_CONTACT_TITLE_MISS)) == -1 ? false : true} onChange={(e) => { i.identity = handleArrayValue(e.target.checked, e.target.value, i.identity); setUserIpt(p => ({ ...p, shareholders: [...shareholders] })) }} />} label={t(KEY_FORM_VO_COL_MAIN_CONTACT_TITLE_MISS)} />
                                <FormControlLabel value={t(KEY_FORM_VO_COL_MAIN_CONTACT_TITLE_MRS)} control={<Checkbox checked={i.identity.indexOf(t(KEY_FORM_VO_COL_MAIN_CONTACT_TITLE_MRS)) == -1 ? false : true} onChange={(e) => { i.identity = handleArrayValue(e.target.checked, e.target.value, i.identity); setUserIpt(p => ({ ...p, shareholders: [...shareholders] })) }} />} label={t(KEY_FORM_VO_COL_MAIN_CONTACT_TITLE_MRS)} /> */}
                                        </RadioGroup>
                                    </Box>
                                </FormControl>
                            </Grid>
                            <Grid item sm={1} xs={1}></Grid>
                            <Grid item sm={1} xs={1}></Grid>
                            <Grid item sm={5} xs={5}>
                                <FormControl>
                                    <TextField label={t(KEY_FORM_VO_COL_MAIN_CONTACT_NAME_EN)} value={userIpt.en_name} type="text" onChange={(e) => saveValue('en_name', e.target.value)} />
                                </FormControl>
                            </Grid>
                            <Grid item sm={5} xs={5}>
                                <FormControl>
                                    <TextField label={t(KEY_FORM_VO_COL_MAIN_CONTACT_NAME_CN)} type="text" value={userIpt.zh_name} onChange={(e) => saveValue('zh_name', e.target.value)} />
                                </FormControl>
                            </Grid>
                            <Grid item sm={1} xs={1}></Grid>
                            <Grid item sm={1} xs={1}></Grid>
                            <Grid item sm={10} xs={10}>
                                <FormControl>
                                    <TextField label={t(KEY_FORM_VO_COL_MAIN_CONTACT_ADDRESS)} type="text" value={userIpt.address} onChange={(e) => saveValue('address', e.target.value)} />
                                </FormControl>
                            </Grid>
                            <Grid item sm={1} xs={1}></Grid>

                            {/* offset-4 */}
                            <Grid item sm={1} xs={1}></Grid>
                            <Grid item sm={10} xs={10}>
                                <Grid item sm={12} xs={12}>&nbsp;</Grid>
                                <Grid item sm={12} xs={12}>&nbsp;</Grid>
                                <Typography variant='h6'>{t(KEY_FORM_VO_COL_NEED_UPLOAD_FILE)}</Typography>

                                <Typography variant='h5'>
                                    {t(KEY_FORM_VO_COL_IND_FILE_ADDRESS_COPY)}
                                    {
                                        fileStatus.file_address
                                            ? <CheckIcon color='primary' fontSize='large' />
                                            : <UploadButton fileName={t(KEY_FORM_VO_COL_IND_FILE_ADDRESS_COPY)} uid={user?.id} sid={toInteger(userIpt.page)} usid={0} customFn={(payload) => setFileStatus(p => ({ ...p, "file_address": payload }))}>
                                                <FileUploadIcon />
                                            </UploadButton>
                                    }
                                </Typography>
                            </Grid>
                            <Grid item sm={1} xs={1}></Grid>
                        </>
                    )
                case t(KEY_FORM_VO_COL_IDENTITY_ORG):
                    return (
                        <>
                            <Grid item sm={1} xs={1}></Grid>
                            <Grid item sm={5} xs={5}>
                                <FormControl>
                                    <TextField label={t(KEY_LABEL_FORM_COM_EN_NAME)} type="text" value={userIpt.company_name_en} onChange={(e) => saveValue('company_name_en', e.target.value)} />
                                </FormControl>
                            </Grid>
                            <Grid item sm={5} xs={5}>
                                <FormControl>
                                    <TextField label={t(KEY_LABEL_FORM_COM_CN_NAME)} type="text" value={userIpt.company_name_zh} onChange={(e) => saveValue('company_name_zh', e.target.value)} />
                                </FormControl>
                            </Grid>
                            <Grid item sm={1} xs={1}></Grid>

                            <Grid item sm={1} xs={1}></Grid>
                            <Grid item sm={5} xs={5}>
                                <FormControl>
                                    <TextField label={t(KEY_FORM_VO_COL_REG_CONNTRY)} type="text" value={userIpt.reg_country} onChange={(e) => saveValue('reg_country', e.target.value)} />
                                </FormControl>
                            </Grid>
                            <Grid item sm={5} xs={5}>
                                <FormControl>
                                    <TextField label={t(KEY_FORM_VO_COL_ORG_NUM)} type="text" value={userIpt.org_num} onChange={(e) => saveValue('org_num', e.target.value)} />
                                </FormControl>
                            </Grid>
                            <Grid item sm={1} xs={1}></Grid>

                            {/* offset-4 */}
                            <Grid item sm={1} xs={1}></Grid>
                            <Grid item sm={10} xs={10}>
                                <Grid item sm={12} xs={12}>&nbsp;</Grid>
                                <Grid item sm={12} xs={12}>&nbsp;</Grid>
                                <Typography variant='h6'>{t(KEY_FORM_VO_COL_NEED_UPLOAD_FILE)}</Typography>

                                <Typography variant='h5'>
                                    {t(KEY_FORM_VO_COL_ORG_FILE_ORG_COPY)}
                                    {
                                        fileStatus.file_org
                                            ? <CheckIcon color='primary' fontSize='large' />
                                            : <UploadButton fileName={t(KEY_FORM_VO_COL_ORG_FILE_ORG_COPY)} uid={user?.id} sid={toInteger(userIpt.page)} usid={0} customFn={(payload) => setFileStatus(p => ({ ...p, "file_org": payload }))}>
                                                <FileUploadIcon />
                                            </UploadButton>
                                    }
                                </Typography>
                            </Grid>
                            <Grid item sm={1} xs={1}></Grid>
                        </>
                    )

                default:
                    return (
                        <>
                            <Grid item sm={1} xs={1}></Grid>
                            <Grid item sm={5} xs={5}>
                                <FormControl>
                                    <TextField label={t(KEY_LABEL_FORM_COM_EN_NAME)} type="text" value={userIpt.company_name_en} onChange={(e) => saveValue('company_name_en', e.target.value)} />
                                </FormControl>
                            </Grid>
                            <Grid item sm={5} xs={5}>
                                <FormControl>
                                    <TextField label={t(KEY_LABEL_FORM_COM_CN_NAME)} type="text" value={userIpt.company_name_zh} onChange={(e) => saveValue('company_name_zh', e.target.value)} />
                                </FormControl>
                            </Grid>
                            <Grid item sm={1} xs={1}></Grid>

                            <Grid item sm={1} xs={1}></Grid>
                            <Grid item sm={5} xs={5}>
                                <FormControl>
                                    <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                                        <FormLabel id="demo-radio-buttons-group-label" sx={{ mr: 2 }}>{t(KEY_FORM_VO_COL_BUS_REG_LICENSE)} </FormLabel>
                                        <RadioGroup
                                            row
                                            aria-labelledby="demo-radio-buttons-group-label"
                                            defaultValue="1"
                                            value={userIpt.has_bus_reg_license}
                                            name="has_bus_reg_license"
                                            onChange={(e) => saveValue('has_bus_reg_license', e.target.value)}
                                        >
                                            <FormControlLabel value="1" control={<Radio />} label={t(KEY_FORM_VO_COL_BUS_REG_LICENSE_YES)} />
                                            <FormControlLabel value="0" control={<Radio />} label={t(KEY_FORM_VO_COL_BUS_REG_LICENSE_NO)} />
                                        </RadioGroup>
                                    </Box>
                                </FormControl>
                            </Grid>
                            <Grid item sm={5} xs={5}>
                                <FormControl>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            label={t(KEY_FORM_VO_COL_REG_DATE)}
                                            // value={userIpt.reg_date}
                                            onChange={(newValue) => saveValue('reg_date', newValue)}
                                        />
                                    </LocalizationProvider>
                                </FormControl>
                            </Grid>
                            <Grid item sm={1} xs={1}></Grid>
                            {
                                userIpt.has_bus_reg_license == '0'
                                    ? (
                                        <>
                                            <Grid item sm={1} xs={1}></Grid>
                                            <Grid item sm={10} xs={10}>
                                                <FormControl>
                                                    <TextField label={t(KEY_FORM_VO_COL_BUS_REG_NUM)} type="text" value={userIpt.bus_reg_num} onChange={(e) => saveValue('bus_reg_num', e.target.value)} />
                                                </FormControl>
                                            </Grid>
                                            <Grid item sm={1} xs={1}></Grid>
                                        </>
                                    )
                                    : false
                            }

                            {/* offset-4 */}
                            <Grid item sm={1} xs={1} ></Grid>
                            <Grid item sm={10} xs={10}>
                                <Grid item sm={12} xs={12}>&nbsp;</Grid>
                                <Grid item sm={12} xs={12}>&nbsp;</Grid>
                                <Typography variant='h6'>{t(KEY_FORM_VO_COL_NEED_UPLOAD_FILE)}</Typography>

                                <Typography variant='h5'>
                                    {t(KEY_FORM_VO_COL_FILE_BUG_REG_COPY)}
                                    {
                                        fileStatus.file_bug_reg
                                            ? <CheckIcon color='primary' fontSize='large' />
                                            : <UploadButton fileName={t(KEY_FORM_VO_COL_FILE_BUG_REG_COPY)} uid={user?.id} sid={toInteger(userIpt.page)} usid={0} customFn={(p) => setFileStatus(p => ({ ...p, "file_bug_reg": p }))}>
                                                <FileUploadIcon />
                                            </UploadButton>
                                    }
                                </Typography>
                            </Grid>
                            <Grid item sm={1} xs={1}></Grid>
                        </>
                    )
            }
        }

        function renderTAC() {
            switch (userIpt.title) {
                case t(KEY_FORM_VO_COL_IDENTITY_COM):
                    return (
                        <>
                            <Grid item sm={1} xs={1}></Grid>
                            <Grid item sm={10} xs={10}>
                                <Typography variant='h5'>{t(KEY_FORM_VO_TAC_COM_1)}</Typography>
                                <Typography variant='h5'>{t(KEY_FORM_VO_TAC_COM_2)}</Typography>
                                <Typography variant='h5'>{t(KEY_FORM_VO_TAC_COM_3)}</Typography>
                                <Grid item sm={12} xs={12}>&nbsp;</Grid>
                                <Typography variant='p'>{t(KEY_FORM_VO_TAC_TIPS)}</Typography>
                            </Grid>
                            <Grid item sm={1} xs={1}></Grid>
                        </>
                    )
                case t(KEY_FORM_VO_COL_IDENTITY_IND):
                    return (
                        <>
                            <Grid item sm={1} xs={1}></Grid>
                            <Grid item sm={10} xs={10}>
                                <Typography variant='h5'>{t(KEY_FORM_VO_TAC_IND_1)}</Typography>
                                <Typography variant='h5'>{t(KEY_FORM_VO_TAC_IND_2)}</Typography>
                                <Grid item sm={12} xs={12}>&nbsp;</Grid>
                                <Typography variant='p'>{t(KEY_FORM_VO_TAC_TIPS)}</Typography>
                            </Grid>
                            <Grid item sm={1} xs={1}></Grid>
                        </>
                    )
                case t(KEY_FORM_VO_COL_IDENTITY_ORG):
                    return (
                        <>
                            <Grid item sm={1} xs={1}></Grid>
                            <Grid item sm={10} xs={10} >
                                <Typography variant='h5'>{t(KEY_FORM_VO_TAC_ORG_1)}</Typography>
                                <Typography variant='h5'>{t(KEY_FORM_VO_TAC_ORG_2)}</Typography>
                                <Grid item sm={12} xs={12}>&nbsp;</Grid>
                                <Typography variant='p'>{t(KEY_FORM_VO_TAC_TIPS)}</Typography>
                            </Grid>
                            <Grid item sm={1} xs={1}></Grid>
                        </>
                    )

                default:
                    return (
                        <>
                            <Grid item sm={1} xs={1}></Grid>
                            <Grid item sm={10} xs={10}>
                                <Typography variant='h5'>{t(KEY_FORM_VO_TAC_COM_1)}</Typography>
                                <Typography variant='h5'>{t(KEY_FORM_VO_TAC_COM_2)}</Typography>
                                <Typography variant='h5'>{t(KEY_FORM_VO_TAC_COM_3)}</Typography>
                                <Grid item sm={12} xs={12}>&nbsp;</Grid>
                                <Typography variant='p'>{t(KEY_FORM_VO_TAC_TIPS)}</Typography>
                            </Grid>
                            <Grid item sm={1} xs={1}></Grid>
                        </>
                    )
            }
        }

        switch (step) {
            case 0:
                return (
                    <RBox
                        component="form"
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            flexWrap: 'wrap',
                            rowGap: 2,
                            columnGap: 0.5,
                            m: '0 auto',
                            '& .MuiFormControl-root': { width: '100%' },
                            '& .MuiTextField-root': { width: '100%' },
                        }}

                        noValidate
                        autoComplete="off"
                    >
                        <Grid container spacing={2}>
                            <Grid item sm={1} xs={1}></Grid>
                            <Grid item sm={11} xs={11}>
                                <FormControl>
                                    <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                                        <Grid container spacing={2}>
                                            <Grid item sm={12} xs={12}>
                                                {/* <FormLabel id="demo-radio-buttons-group-label" sx={{ mr: 2 }}>{steps[0]} </FormLabel> */}
                                            </Grid>
                                            <Grid item sm={12} xs={12}>
                                                <RadioGroup
                                                    row
                                                    aria-labelledby="demo-radio-buttons-group-label"
                                                    value={userIpt.page}
                                                    name="page"
                                                    onChange={(e) => saveValue('page', e.target.value)}
                                                >
                                                    <Grid container spacing={2}>
                                                        {
                                                            plans.map(
                                                                i => (
                                                                    <Grid item sm={12} xs={12} key={i.id}>
                                                                        <FormControlLabel value={i.id} control={<Radio />} label={i.locale_name + " -- " + "HKD" + i.current_price} />
                                                                        <br />
                                                                        <Typography variant='p'>
                                                                            {
                                                                                lng === ZH
                                                                                    ? i?.content_tc
                                                                                    : lng === ZH_CN
                                                                                        ? i?.content_cn
                                                                                        : lng === EN
                                                                                            ? i?.content_en
                                                                                            : i?.content
                                                                            }
                                                                        </Typography>
                                                                    </Grid>
                                                                )
                                                            )
                                                        }
                                                    </Grid>
                                                    {/* <FormControlLabel value="成立香港有限公司" control={<Radio />} label="成立香港有限公司" />
                                            <FormControlLabel value="購買香港現成有限公司" control={<Radio />} label="購買香港現成有限公司" />
                                            <FormControlLabel value="成立香港無限有限公司" control={<Radio />} label="成立香港無限有限公司" /> */}
                                                </RadioGroup>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </RBox>
                )
            case 1:
                return (
                    <RBox
                        component="form"
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            flexWrap: 'wrap',
                            rowGap: 2,
                            columnGap: 0.5,
                            m: '0 auto',
                            '& .MuiFormControl-root': { width: '100%' },
                            '& .MuiTextField-root': { width: '100%' },
                        }}

                        noValidate
                        autoComplete="off"
                    >
                        <Grid container spacing={2}>
                            <Grid item sm={1} xs={1}></Grid>
                            <Grid item sm={10} xs={10}>
                                <FormControl>
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        <FormLabel id="demo-radio-buttons-group-label" sx={{ mr: 2 }}>{t(KEY_FORM_VO_COL_IDENTITY)} </FormLabel>
                                        <RadioGroup
                                            row
                                            aria-labelledby="demo-radio-buttons-group-label"
                                            defaultValue={t(KEY_FORM_VO_COL_IDENTITY_COM)}
                                            value={userIpt.title}
                                            name="title"
                                            onChange={(e) => saveValue('title', e.target.value)}
                                        >
                                            <FormControlLabel value={t(KEY_FORM_VO_COL_IDENTITY_COM)} control={<Radio />} label={t(KEY_FORM_VO_COL_IDENTITY_COM)} />
                                            <FormControlLabel value={t(KEY_FORM_VO_COL_IDENTITY_IND)} control={<Radio />} label={t(KEY_FORM_VO_COL_IDENTITY_IND)} />
                                            <FormControlLabel value={t(KEY_FORM_VO_COL_IDENTITY_ORG)} control={<Radio />} label={t(KEY_FORM_VO_COL_IDENTITY_ORG)} />
                                        </RadioGroup>
                                    </Box>
                                </FormControl>
                            </Grid>
                            <Grid item sm={1} xs={1}></Grid>

                            {renderPInfo()}

                        </Grid>
                    </RBox>
                );

            case 2:
                return (
                    <RBox
                        component="form"
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            flexWrap: 'wrap',
                            rowGap: 2,
                            columnGap: 0.5,
                            m: '0 auto',
                            '& .MuiFormControl-root': { width: '100%' },
                            '& .MuiTextField-root': { width: '100%' },
                        }}
                        noValidate
                        autoComplete="off"
                    >
                        <Grid container spacing={2}>
                            <Grid item sm={1} xs={1}></Grid>
                            <Grid item sm={11} xs={11}>
                                <FormControl>
                                    <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                                        <FormLabel id="demo-radio-buttons-group-label" sx={{ mr: 2 }}>{t(KEY_FORM_VO_COL_MAIN_CONTACT)} </FormLabel>
                                        <RadioGroup
                                            row
                                            aria-labelledby="demo-radio-buttons-group-label"
                                            defaultValue="1"
                                            value={shareholders.length}
                                            name="sMemberNum"
                                            onChange={(e) => {
                                                saveValue('sMemberNum', e.target.value)
                                                setShareholders(p => {
                                                    setUserIpt(pp => ({ ...pp, shareholders: p.slice(0, toInteger(e.target.value)) }))
                                                    return p.slice(0, toInteger(e.target.value))
                                                })
                                            }}
                                        >
                                            <FormControlLabel value="1" control={<Radio />} label="1" />
                                            <FormControlLabel value="2" control={<Radio />} label="2" />
                                            <FormControlLabel value="3" control={<Radio />} label="3" />
                                            <FormControlLabel value="4" control={<Radio />} label="4" />
                                            <FormControlLabel value="5" control={<Radio />} label="5" />
                                            <FormControlLabel value="5" control={<Button children={t(KEY_LABEL_FORM_BOARD_NUM_NEW)} onClick={addNewShareholder} />} />
                                        </RadioGroup>
                                    </Box>
                                </FormControl>
                            </Grid>
                            {
                                // memberNoRenderer(userIpt.sMemberNum)
                                shareholderLayoutRenderer()
                            }

                        </Grid>
                    </RBox>
                )

            case 3:
                return (
                    <RBox
                        component="form"
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            flexWrap: 'wrap',
                            rowGap: 2,
                            columnGap: 0.5,
                            m: '0 auto',
                            '& .MuiFormControl-root': { width: '100%' },
                            '& .MuiTextField-root': { width: '100%' },
                        }}
                        noValidate
                        autoComplete="off"
                    >
                        <Grid container spacing={2}>
                            <Grid item sm={1} xs={1}></Grid>
                            <Grid item sm={10} xs={10}>
                                <FormControl>
                                    <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                                        <FormLabel id="demo-radio-buttons-group-label" sx={{ mr: 2 }}>{t(KEY_LABEL_FORM_VALUE_ADDED)} </FormLabel>
                                        <RadioGroup
                                            row
                                            aria-labelledby="demo-radio-buttons-group-label"
                                            value={userIpt.eService}
                                            name="eService"
                                        >
                                            {/* {
                                                services.filter(i => i.name.includes('value_added_service') && !i.name.includes('serviced_office'))
                                                    .map(i => <FormControlLabel value={i.id} control={<Checkbox checked={userIpt.eService.indexOf(i.id) == -1 ? false : true} onChange={(e) => saveValue('eService', handleArrayValue(e.target.checked, e.target.value, userIpt.eService))} />} label={i.locale_name} />)
                                            } */}
                                            <FormControlLabel value="16" control={<Checkbox checked={userIpt.eService.indexOf('16') == -1 ? false : true} onChange={(e) => saveValue('eService', handleArrayValue(e.target.checked, e.target.value, userIpt.eService))} />} label={t(KEY_LABEL_FORM_VALUE_ADDED_BE)} />
                                            <FormControlLabel value="12" control={<Checkbox checked={userIpt.eService.indexOf('12') == -1 ? false : true} onChange={(e) => saveValue('eService', handleArrayValue(e.target.checked, e.target.value, userIpt.eService))} />} label={t(KEY_LABEL_FORM_VALUE_ADDED_CP_1)} />
                                            <FormControlLabel value="13" control={<Checkbox checked={userIpt.eService.indexOf('13') == -1 ? false : true} onChange={(e) => saveValue('eService', handleArrayValue(e.target.checked, e.target.value, userIpt.eService))} />} label={t(KEY_LABEL_FORM_VALUE_ADDED_CP_2)} />
                                        </RadioGroup>
                                    </Box>
                                </FormControl>
                            </Grid>
                            <Grid item sm={1} xs={1}></Grid>
                        </Grid>
                    </RBox>
                )

            case 4:
                return (
                    <RBox
                        component="form"
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            flexWrap: 'wrap',
                            rowGap: 2,
                            columnGap: 0.5,
                            m: '0 auto',
                            '& .MuiFormControl-root': { width: '100%' },
                            '& .MuiTextField-root': { width: '100%' },
                        }}
                        noValidate
                        autoComplete="off"
                    >
                        <Grid container spacing={2}>
                            {renderTAC()}
                        </Grid>
                    </RBox>
                )

            default:
                break;
        }
    }, [userIpt, plans, shareholders, fileStatus, fileStatus.file_hkid])

    React.useEffect(() => {
        const temp = resp_services?.value?.value.filter(i => i.name.includes(serveAs)).sort((a, b) => a.id - b.id)
        setPlans(temp)
        setUserIpt(p => ({ ...p, page: temp[0]?.id }))
        setActiveStep(0)
    }, [serveAs])

    React.useEffect(() => {
        getSListFn()
            .then(res => {
                if (res.data?.data) {
                    setPlans(
                        res.data?.data?.services?.data.filter(i => i.name.includes(serveAs)).sort((a, b) => a.id - b.id)
                    )
                }
            })
    }, [serveAs, lng])

    const formPreviewRenderer = React.useMemo(() => <PreviewForm_vo {...userIpt} />, [userIpt])

    return (
        <Box sx={{ width: '100%' }}>
            <Stepper className='stepper-hor' activeStep={activeStep} size='sm' sx={{
                mb: 6,

            }} >
                {steps.map((label, index) => {
                    const stepProps = {};
                    const labelProps = {};
                    if (isStepOptional(index)) {
                        labelProps.optional = (
                            <Typography variant="caption">可選</Typography>
                        );
                    }
                    if (isStepSkipped(index)) {
                        stepProps.completed = false;
                    }
                    return (
                        <Step key={label} {...stepProps}>
                            <StepLabel {...labelProps} >
                                <Typography variant='span' sx={{ fontSize: 16 }}>{label}</Typography>
                            </StepLabel>
                        </Step>
                    );
                })}
            </Stepper>

            {activeStep === steps.length ? (
                <React.Fragment>
                    {/* <Typography sx={{ mt: 2, mb: 1 }}>
                        已遞交
                    </Typography> */}
                    {formPreviewRenderer}
                    <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                        <Button
                            color="inherit"
                            disabled={activeStep === 0}
                            variant='contained'
                            onClick={handleBack}
                            sx={{ mr: 1 }}
                        >
                            {t(KEY_LABEL_FORM_PREVIOUS)}
                        </Button>
                        <Box sx={{ flex: '1 1 auto' }} />
                        <Button variant='contained' onClick={submit ? () => { } : handleReset}>{t(KEY_LABEL_FORM_SUBMIT)}</Button>
                    </Box>
                </React.Fragment>
            ) : (
                <React.Fragment>
                    <Typography variant='h5' sx={{ mt: 2, mb: 2, ml: 1, pt: 1, pb: 1, border: '1px solid #aaa', borderLeftWidth: 0, borderRightWidth: 0 }}>{steps[activeStep]}</Typography>
                    {formSectionRenderer(activeStep)}
                    <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                        <Button
                            color="inherit"
                            variant='contained'
                            disabled={activeStep === 0}
                            onClick={handleBack}
                            sx={{ mr: 1 }}
                        >
                            {t(KEY_LABEL_FORM_PREVIOUS)}
                        </Button>
                        <Box sx={{ flex: '1 1 auto' }} />
                        {/* {isStepOptional(activeStep) && (
                            <Button color="inherit" onClick={handleSkip} sx={{ mr: 1 }}>
                                Skip
                            </Button>
                        )} */}

                        <Button variant='contained' onClick={handleNext}>
                            {activeStep === steps.length - 1 ? t(KEY_FORM_VO_CONFIRM) : t(KEY_LABEL_FORM_NEXT)}
                        </Button>
                    </Box>
                </React.Fragment>
            )}
        </Box>
    );
}
